module.exports = __webpack_public_path__ + "static/media/solution-tube-s-2.f58ceb50.svg";